export const MfaFlow = {
    Login: 'Login',
    ResetPassword: 'ResetPassword',
    UpdatePassword: 'UpdatePassword',
    Withdrawal: 'Withdrawal',
    CloseAccount: 'CloseAccount',
    ReopenAccount: 'ReopenAccount',
    BankAccountManagement: 'BankAccountManagement',
    UpdatePhoneNumber: 'UpdatePhoneNumber',
} as const;
export type MfaFlow = typeof MfaFlow[keyof typeof MfaFlow];

export const SecurityCheckModalsGroup = 'securityCheck';

type MfaFlowProps = {
    intro?: {
        modalTitle?: string;
        bannerTitle?: string;
        bannerDescription?: string;
        continueCtaLabel?: string;
        bannerCtaLabel?: string;
        dataNotice?: string;
    },
    success?: {
        modalTitle?: string;
        modalDescription?: string;
        primaryCta?: string;
        illustrationName?: string;
    },
    error?: {
        modalTitle?: string;
        modalDescription?: string;
        primaryCta?: string;
        secondaryCta?: string;
    },
};

export const MfaFlowPayload: Record<MfaFlow, MfaFlowProps> = {
    [MfaFlow.Login]: {},
    [MfaFlow.ResetPassword]: {
        intro: {
            modalTitle: 'pam.resetPassword.introSecurity.title',
            bannerTitle: 'pam.resetPassword.introSecurity.bannerTitle',
            bannerDescription: 'pam.resetPassword.introSecurity.bannerDescription',
            continueCtaLabel: 'pam.resetPassword.introSecurity.continue',
        },
        success: {
            modalTitle: 'pam.resetPassword.success.title',
            modalDescription: 'pam.resetPassword.success.description',
            primaryCta: 'pam.resetPassword.success.cta',
        },
    },
    [MfaFlow.UpdatePassword]: {
        intro: {
            bannerDescription: 'pam.updatePassword.security.bannerDescription',
        },
    },
    [MfaFlow.Withdrawal]: {
        error: {
            modalTitle: 'wallet.securityCheckError.modal.title',
            modalDescription: 'wallet.securityCheckError.modal.description',
            primaryCta: 'wallet.securityCheckError.modal.retry',
            secondaryCta: 'wallet.securityCheckError.modal.contactSupport',
        },
    },
    [MfaFlow.BankAccountManagement]: {
        error: {
            modalTitle: 'wallet.securityCheckError.modal.title',
            modalDescription: 'wallet.securityCheckError.modal.description',
            primaryCta: 'wallet.securityCheckError.modal.retry',
            secondaryCta: 'wallet.securityCheckError.modal.contactSupport',
        },
    },
    [MfaFlow.CloseAccount]: {
        intro: {
            bannerDescription: 'pam.closeAccount.introSecurity.bannerDescription',
        },
        success: {
            modalTitle: 'pam.closeAccount.success.title',
            modalDescription: 'pam.closeAccount.success.description',
            illustrationName: 'profile-closure',
            primaryCta: 'pam.closeAccount.success.cta',
        },
    },
    [MfaFlow.ReopenAccount]: {
        success: {
            modalTitle: 'pam.mfaReopenAccount.success.title',
            modalDescription: 'pam.mfaReopenAccount.success.description',
            primaryCta: 'pam.mfaReopenAccount.success.cta',
        },
    },
    [MfaFlow.UpdatePhoneNumber]: {
        intro: {
            bannerDescription: 'pam.updatePhoneNumber.introSecurity.bannerDescription',
        },
    },
} as const;
export type MfaFlowPayload = typeof MfaFlowPayload[keyof typeof MfaFlowPayload];

export function getMfaFlowPayload(flow: MfaFlow): MfaFlowPayload | undefined {
    return MfaFlowPayload[flow];
}
